import ClaimDetailDialog from "./claimDetailDialog.container"

export default ClaimDetailDialog;